import { InstrumentDetailForm } from "../components/instruments/InstrumentDetailForm";
import { Section } from "../components/Section";

export function NewInstrumentPage() {
  return (
    <div className="flex flex-col flex-1 max-w-3xl">
      <Section.Title>New instrument</Section.Title>
      <InstrumentDetailForm />
    </div>
  );
}
